export default __webpack_public_path__ + "static/team-building-website-7fe859ed8b013c0af0865715514373cf.svg";